(function () {
  'use strict';

  let selectedValues = [];
  let selectedTags = [];

  const questions = [
    {
      question: 'Your Skin Goal',
      options: [
        { value: 'Glow + Radiance', tag: 'combo_filter_glow_radiance' },
        { value: 'Acne Clear', tag: 'combo_filter_acne_clear' },
        { value: 'Deep Hydration', tag: 'combo_filter_deep_hydration' },
        { value: 'Anti Ageing', tag: 'combo_filter_anti_ageing' },
        { value: 'Sun Protection', tag: 'combo_filter_sun_protection' },
        { value: 'oil control', tag: 'combo_filter_oil_control' },
        { value: 'Chapped Lips', tag: 'combo_filter_chapped_lips' },
        { value: 'Pigmented Lips', tag: 'combo_filter_pigmented_lips' }
      ]
    },
    {
      question: ' Routine Depth',
      options: [
        { value: 'Duo', subtitle: '2 Steps', tag: 'Duo' },
        { value: 'Trio', subtitle: '3 Steps', tag: 'Trio' },
        { value: 'Full Regime', subtitle: '4+ Steps', tag: 'Full_Regime' }
      ]
    }
  ];

  // Robust scroll lock (works on iOS Safari + themes that scroll the
  // <html> element instead of <body>). We freeze the body with
  // position:fixed at the current scroll offset, then restore the
  // exact scroll position on unlock.
  let savedScrollY = 0;

  const lockBodyScroll = () => {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  };

  const unlockBodyScroll = () => {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);
  };

  const openQuizPopup = () => {
    const popup = document.querySelector('.quiz-popup-container');
    if (!popup) {
      console.error('[ComboQuiz] ERROR: .quiz-popup-container not found in DOM');
      return;
    }

    popup.classList.add('active');
    document.body.classList.add('popup-active');
    lockBodyScroll();

    if (!document.querySelector('.popup-overlay')) {
      const overlay = document.createElement('div');
      overlay.classList.add('popup-overlay');
      // Force the overlay UNDER the popup so it can never sit on top of
      // the close button and swallow its clicks.
      overlay.style.zIndex = '998';
      popup.style.zIndex = '997';
      document.body.appendChild(overlay);
    }

    renderAllQuestions();
  };

  const closeQuizPopup = () => {
    const popup = document.querySelector('.quiz-popup-container');
    if (!popup) return;

    popup.classList.remove('active');
    document.body.classList.remove('popup-active');
    unlockBodyScroll();

    const overlay = document.querySelector('.popup-overlay');
    if (overlay) overlay.remove();

    selectedValues = [];
    selectedTags = [];
    const resultContainer = document.querySelector('.result-container');
    if (resultContainer) {
      resultContainer.style.display = 'none';
      resultContainer.innerHTML = '';
    }

    renderAllQuestions();
  };

  // Event delegation so it works even if the section HTML is injected
  // after this script runs. preventDefault() on the close button since
  // #popupCloseBtn/.start_btn can otherwise submit a form or navigate
  // instead of just toggling the popup; the overlay click also closes it.
  document.addEventListener('click', (e) => {
    const startBtnHit = e.target.closest('.start_btn');
    const closeBtnHit = e.target.closest('#popupCloseBtn, .popup-overlay');

    if (startBtnHit) {
      e.preventDefault();
      openQuizPopup();
      return;
    }
    if (closeBtnHit) {
      e.preventDefault();
      e.stopPropagation();
      closeQuizPopup();
    }
  });

  function renderAllQuestions() {
    const sectionsContainer = document.getElementById('quizSectionsContainer');
    if (!sectionsContainer) {
      return;
    }
    sectionsContainer.innerHTML = '';

    questions.forEach((currentQuestion, qIndex) => {
      const section = document.createElement('div');
      section.classList.add('quiz-section');

      const heading = document.createElement('h3');
      heading.classList.add('quiz-question');
      heading.textContent = `${qIndex + 1}. ${currentQuestion.question}`;
      section.appendChild(heading);

      const optionContainer = document.createElement('div');
      optionContainer.classList.add('quiz-option-container');
      optionContainer.setAttribute('data-question-index', qIndex);
      if (currentQuestion.options.length === 3) {
        optionContainer.classList.add('quiz-option-container--triple');
      }

      currentQuestion.options.forEach((option) => {
        const optionDiv = document.createElement('div');
        optionDiv.classList.add('quiz-option');
        optionDiv.setAttribute('data-value', option.value);
        optionDiv.setAttribute('data-tag', option.tag);

        if (option.subtitle) {
          optionDiv.classList.add('has-subtitle');

          const optionTitle = document.createElement('span');
          optionTitle.classList.add('option-title');
          optionTitle.textContent = option.value;
          optionDiv.appendChild(optionTitle);

          const optionSubtitle = document.createElement('span');
          optionSubtitle.classList.add('option-subtitle');
          optionSubtitle.textContent = option.subtitle;
          optionDiv.appendChild(optionSubtitle);
        } else {
          const optionText = document.createElement('span');
          optionText.textContent = option.value;
          optionDiv.appendChild(optionText);
        }

        if (selectedValues[qIndex] === option.value) {
          optionDiv.classList.add('selected');
        }

        optionDiv.addEventListener('click', function () {
          optionContainer.querySelectorAll('.quiz-option').forEach((opt) => opt.classList.remove('selected'));
          this.classList.add('selected');

          selectedValues[qIndex] = option.value;
          selectedTags[qIndex] = option.tag;

          checkAndShowResults();
        });

        optionContainer.appendChild(optionDiv);
      });

      section.appendChild(optionContainer);
      sectionsContainer.appendChild(section);
    });
  }

  function checkAndShowResults() {
    const answeredCount = selectedTags.filter(Boolean).length;
    const resultContainer = document.querySelector('.result-container');

    if (answeredCount === questions.length) {
      showResults();
    } else {
      resultContainer.style.display = 'none';
      resultContainer.innerHTML = '';
    }
  }

  function showResults() {
    const mainDiv = document.querySelector('.result-container');
    mainDiv.innerHTML = '';
    mainDiv.style.display = 'block';

    const divider = document.createElement('hr');
    divider.classList.add('result-divider');
    mainDiv.appendChild(divider);

    const resultCountHeader = document.createElement('div');
    resultCountHeader.classList.add('result-count-header');
    mainDiv.appendChild(resultCountHeader);

    const resultsGrid = document.createElement('div');
    resultsGrid.classList.add('result-products-grid');
    mainDiv.appendChild(resultsGrid);

    const allCards = document.querySelectorAll('#allComboCards .combo-card-hidden-wrapper');

    const matchingCards = Array.from(allCards).filter((cardWrapper) => {
      const cardTags = (cardWrapper.getAttribute('data-tags') || '')
        .split(',')
        .map((t) => t.trim());
      return selectedTags.every((tag) => cardTags.includes(tag));
    });

    resultCountHeader.innerHTML = matchingCards.length > 0
      ? `<strong>${matchingCards.length}</strong> <em>Result${matchingCards.length > 1 ? 's' : ''}</em>`
      : '<strong>0</strong> <em>Results</em>';

    if (matchingCards.length > 0) {
      matchingCards.forEach((cardWrapper) => {
        const clone = cardWrapper.cloneNode(true);
        clone.style.display = '';
        resultsGrid.appendChild(clone);
      });
    } else {
      mainDiv.innerHTML += '<h3>Sorry, No Matching <span>Combo</span> Found For Your Match.</h3>';
    }
  }
})();
